function isMobile() {
  return window.matchMedia("(max-width: 768px)").matches ||
    'ontouchstart' in window;
}

function initMarketingOpSearch() {
  const searchInput = document.querySelector('.search-bar .search-bar__input');
  searchInput.addEventListener("input", (e) => {
    if (e.target.value.includes(marketing.operation.launcher)) {
      const handle = marketing.operation.product;
      let langPrefix = '';
      if (marketing.operation.locale) {
        langPrefix = '/' + marketing.operation.locale;
      }
      const productMarketingUrl = `${langPrefix}/products/${handle}`;
      window.location.href = productMarketingUrl;
    }
  });
}

function rainBananas() {
  if (isMobile()) {
    maxBananas = 15;
  } else {
    maxBananas = 35;
  }
  for (let i = 0; i < maxBananas; i++) {
    createBanana();
  }
}

function createBanana() {
  const banana = document.createElement('div');
  banana.classList.add('banana');

  // Position horizontale
  banana.style.left = (-5 + Math.random() * 105) + 'vw';

  // position verticale
  banana.style.top = (-150 - Math.random() * 200) + 'px';

  // Taille aléatoire
  if (isMobile()) {
    size = 40 + Math.random() * 40;
  } else {
    size = 60 + Math.random() * 60;
  }

  banana.style.width = size + 'px';
  banana.style.height = size + 'px';

  // Durée aléatoire
  banana.style.animationDuration = (1 + Math.random() * 2) + 's';

  document.body.appendChild(banana);

  setTimeout(() => {
    banana.remove();
  }, 8000);
}

function marketingOpAddToCartAnimation() {
  const mixMatchAddToCart = document.querySelector('#buyButton');
  if (mixMatchAddToCart) {
    mixMatchAddToCart.addEventListener('click', function() {
      const inputs = [
        document.querySelector("#sample-input-1"),
        document.querySelector("#sample-input-2"),
        document.querySelector("#sample-input-3")
      ];

      const hasBanana = inputs.some(input =>
        input && input.value.includes("Banana")
      );

      if (hasBanana) {
        rainBananas();
      }
    });
  }
  const bananaAddToCart = document.querySelector('[data-marketing-animation="true"] .product-form__cart-submit');
  if (bananaAddToCart) {
    bananaAddToCart.addEventListener('click', rainBananas);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (marketing.operation.search_redirect) {
    initMarketingOpSearch();
  }
  if (marketing.operation.animation_addtocart) {
    marketingOpAddToCartAnimation();
  }
});